import React from 'react';
import SalesProfitInfo from '../../../components/projectmng/obtainorder/SalesProfitInfo';

const SalesProfitInfoContainer = ({ orderInfo, project }) => {
  return <SalesProfitInfo orderInfo={orderInfo} project={project} />;
};

export default SalesProfitInfoContainer;
